// snippets
import React from "react";
import { ColorCubeIcon } from "components/Icons/ColorCubeIcon";
import { packClasses } from "Util";

export default function PrimaryButton({
    label,
    type,
    className,
    children,
    blocking,
    as,
    ...remainder
}) {
    if (as) {
        return React.createElement(
            as,
            Object.assign({}, remainder, {
                className: packClasses(
                    "focus:outline-none inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50",
                    blocking ? "bg-gray-200" : "bg-green-600",
                    className ? className : ""
                ),
            }),
            children
        );
    }
    return (
        <button
            type={type ? type : "button"}
            className={packClasses(
                "focus:outline-none inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50",
                blocking ? "bg-gray-200" : "bg-green-600",
                className ? className : ""
            )}
            {...remainder}
        >
            <ColorCubeIcon
                className={packClasses(
                    blocking ? " opacity-1" : " opacity-0",
                    "absolute mx-auto h-5 w-5 animate-rotate-pulse"
                )}
                key="icn0"
            />
            <span
                className={packClasses(blocking ? " opacity-0" : " opacity-1")}
            >
                {children ? children : label}
            </span>
        </button>
    );
}
